import { CaretUp } from "@phosphor-icons/react";
import { PropsWithChildren, useState } from "react";

type SectionProps = PropsWithChildren<{
  title: string;
  className?: string;
  contentClassName?: string;
  shown?: boolean;
}>;

export default function Section({
  title,
  children,
  className,
  contentClassName,
  shown: defaultShown,
}: SectionProps) {
  const [shown, setShown] = useState(defaultShown);

  return (
    <div className={`${className} p-4`}>
      <div
        className="flex cursor-pointer items-center justify-between gap-3 text-[20px]"
        onClick={() => setShown(!shown)}
      >
        <p className="text-[20px] font-medium">{title}</p>
        <CaretUp
          className={`${shown ? "-rotate-180" : ""} transition-all`}
          weight="bold"
        />
      </div>
      {shown && <div className={`${contentClassName}`}>{children}</div>}
    </div>
  );
}
